import { Component, OnInit, Input } from '@angular/core';
import { NavController, ModalController } from '@ionic/angular';

@Component({
  selector: 'app-epin-claim-success',
  templateUrl: './epin-claim-success.component.html',
  styleUrls: ['./epin-claim-success.component.scss'],
})
export class EpinClaimSuccessComponent implements OnInit {
  @Input() newBalance: number;
  @Input() epinBalance: number;
  @Input() tokenSymbol: string;
  @Input() tokenGuid: any;
  @Input() baseChainSymbol: string;
  @Input() logo: string;

  constructor(
    private nav: NavController,
    private modalController: ModalController
  ) { }

  ngOnInit() {}

  goToBuy() {
    this.modalController.dismiss();
    this.nav.navigateForward(['/wallet/buy-tokens/step-one'], { queryParams: { symbol: this.tokenSymbol, guid: this.tokenGuid, baseChainSymbol: this.baseChainSymbol }});
  }

  goToAssets() {
    this.modalController.dismiss();
    this.nav.navigateForward(['/wallet/assets']);
  }

}
